import React, { PureComponent } from "react";
import PropTypes from "prop-types";

// Components
import Error from "../Components/Error";

class Feedback extends PureComponent {
    render() {
        const { isLoading } = this.props;

        return isLoading ?
            (
                <div className="d-flex justify-content-center text-danger">
                    <i className="fas fa-spinner-third fa-3x fa-spin" />
                </div>
            ) : (
                <Error title="The items you were looking for currently cannot be found"></Error>
            );
    }
}

Feedback.propTypes = {
    isLoading: PropTypes.bool
};

Feedback.defaultProps = {
    isLoading: true
};

export default Feedback;